/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleRpcStatus } from './GoogleRpcStatus';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusFromJSONTyped,
  GoogleRpcStatusToJSON,
  GoogleRpcStatusToJSONTyped,
} from './GoogleRpcStatus';
import type { PipelineTaskDetailChildTask } from './PipelineTaskDetailChildTask';
import {
  PipelineTaskDetailChildTaskFromJSON,
  PipelineTaskDetailChildTaskFromJSONTyped,
  PipelineTaskDetailChildTaskToJSON,
  PipelineTaskDetailChildTaskToJSONTyped,
} from './PipelineTaskDetailChildTask';
import type { V2beta1RuntimeStatus } from './V2beta1RuntimeStatus';
import {
  V2beta1RuntimeStatusFromJSON,
  V2beta1RuntimeStatusFromJSONTyped,
  V2beta1RuntimeStatusToJSON,
  V2beta1RuntimeStatusToJSONTyped,
} from './V2beta1RuntimeStatus';
import type { V2beta1RuntimeState } from './V2beta1RuntimeState';
import {
  V2beta1RuntimeStateFromJSON,
  V2beta1RuntimeStateFromJSONTyped,
  V2beta1RuntimeStateToJSON,
  V2beta1RuntimeStateToJSONTyped,
} from './V2beta1RuntimeState';
import type { V2beta1ArtifactList } from './V2beta1ArtifactList';
import {
  V2beta1ArtifactListFromJSON,
  V2beta1ArtifactListFromJSONTyped,
  V2beta1ArtifactListToJSON,
  V2beta1ArtifactListToJSONTyped,
} from './V2beta1ArtifactList';
import type { V2beta1PipelineTaskExecutorDetail } from './V2beta1PipelineTaskExecutorDetail';
import {
  V2beta1PipelineTaskExecutorDetailFromJSON,
  V2beta1PipelineTaskExecutorDetailFromJSONTyped,
  V2beta1PipelineTaskExecutorDetailToJSON,
  V2beta1PipelineTaskExecutorDetailToJSONTyped,
} from './V2beta1PipelineTaskExecutorDetail';

/**
 * Runtime information of a task execution.
 * @export
 * @interface V2beta1PipelineTaskDetail
 */
export interface V2beta1PipelineTaskDetail {
  /**
   * ID of the parent run.
   * @type {string}
   * @memberof V2beta1PipelineTaskDetail
   */
  run_id?: string;
  /**
   * System-generated ID of a task.
   * @type {string}
   * @memberof V2beta1PipelineTaskDetail
   */
  task_id?: string;
  /**
   * User specified name of a task that is defined in
   * [Pipeline.spec][].
   * @type {string}
   * @memberof V2beta1PipelineTaskDetail
   */
  display_name?: string;
  /**
   * Creation time of a task.
   * @type {Date}
   * @memberof V2beta1PipelineTaskDetail
   */
  create_time?: Date;
  /**
   * Starting time of a task.
   * @type {Date}
   * @memberof V2beta1PipelineTaskDetail
   */
  start_time?: Date;
  /**
   * Completion time of a task.
   * @type {Date}
   * @memberof V2beta1PipelineTaskDetail
   */
  end_time?: Date;
  /**
   *
   * @type {V2beta1PipelineTaskExecutorDetail}
   * @memberof V2beta1PipelineTaskDetail
   */
  executor_detail?: V2beta1PipelineTaskExecutorDetail;
  /**
   *
   * @type {V2beta1RuntimeState}
   * @memberof V2beta1PipelineTaskDetail
   */
  state?: V2beta1RuntimeState;
  /**
   * Execution id of the corresponding entry in ML metadata store.
   * @type {string}
   * @memberof V2beta1PipelineTaskDetail
   */
  execution_id?: string;
  /**
   *
   * @type {GoogleRpcStatus}
   * @memberof V2beta1PipelineTaskDetail
   */
  error?: GoogleRpcStatus;
  /**
   * Input artifacts of the task.
   * @type {{ [key: string]: V2beta1ArtifactList; }}
   * @memberof V2beta1PipelineTaskDetail
   */
  inputs?: { [key: string]: V2beta1ArtifactList };
  /**
   * Output artifacts of the task.
   * @type {{ [key: string]: V2beta1ArtifactList; }}
   * @memberof V2beta1PipelineTaskDetail
   */
  outputs?: { [key: string]: V2beta1ArtifactList };
  /**
   * ID of the parent task if the task is within a component scope.
   * Empty if the task is at the root level.
   * @type {string}
   * @memberof V2beta1PipelineTaskDetail
   */
  parent_task_id?: string;
  /**
   * A sequence of task statuses. This field keeps a record
   * of state transitions.
   * @type {Array<V2beta1RuntimeStatus>}
   * @memberof V2beta1PipelineTaskDetail
   */
  state_history?: Array<V2beta1RuntimeStatus>;
  /**
   * Name of the corresponding pod assigned by the orchestration engine.
   * Also known as node_id.
   * @type {string}
   * @memberof V2beta1PipelineTaskDetail
   */
  pod_name?: string;
  /**
   * Sequence of dependen tasks.
   * @type {Array<PipelineTaskDetailChildTask>}
   * @memberof V2beta1PipelineTaskDetail
   */
  child_tasks?: Array<PipelineTaskDetailChildTask>;
}

/**
 * Check if a given object implements the V2beta1PipelineTaskDetail interface.
 */
export function instanceOfV2beta1PipelineTaskDetail(
  value: object,
): value is V2beta1PipelineTaskDetail {
  return true;
}

export function V2beta1PipelineTaskDetailFromJSON(json: any): V2beta1PipelineTaskDetail {
  return V2beta1PipelineTaskDetailFromJSONTyped(json, false);
}

export function V2beta1PipelineTaskDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1PipelineTaskDetail {
  if (json == null) {
    return json;
  }
  return {
    run_id: json['run_id'] == null ? undefined : json['run_id'],
    task_id: json['task_id'] == null ? undefined : json['task_id'],
    display_name: json['display_name'] == null ? undefined : json['display_name'],
    create_time: json['create_time'] == null ? undefined : new Date(json['create_time']),
    start_time: json['start_time'] == null ? undefined : new Date(json['start_time']),
    end_time: json['end_time'] == null ? undefined : new Date(json['end_time']),
    executor_detail:
      json['executor_detail'] == null
        ? undefined
        : V2beta1PipelineTaskExecutorDetailFromJSON(json['executor_detail']),
    state: json['state'] == null ? undefined : V2beta1RuntimeStateFromJSON(json['state']),
    execution_id: json['execution_id'] == null ? undefined : json['execution_id'],
    error: json['error'] == null ? undefined : GoogleRpcStatusFromJSON(json['error']),
    inputs:
      json['inputs'] == null ? undefined : mapValues(json['inputs'], V2beta1ArtifactListFromJSON),
    outputs:
      json['outputs'] == null ? undefined : mapValues(json['outputs'], V2beta1ArtifactListFromJSON),
    parent_task_id: json['parent_task_id'] == null ? undefined : json['parent_task_id'],
    state_history:
      json['state_history'] == null
        ? undefined
        : (json['state_history'] as Array<any>).map(V2beta1RuntimeStatusFromJSON),
    pod_name: json['pod_name'] == null ? undefined : json['pod_name'],
    child_tasks:
      json['child_tasks'] == null
        ? undefined
        : (json['child_tasks'] as Array<any>).map(PipelineTaskDetailChildTaskFromJSON),
  };
}

export function V2beta1PipelineTaskDetailToJSON(json: any): V2beta1PipelineTaskDetail {
  return V2beta1PipelineTaskDetailToJSONTyped(json, false);
}

export function V2beta1PipelineTaskDetailToJSONTyped(
  value?: V2beta1PipelineTaskDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    run_id: value['run_id'],
    task_id: value['task_id'],
    display_name: value['display_name'],
    create_time:
      value['create_time'] == null ? value['create_time'] : value['create_time'].toISOString(),
    start_time:
      value['start_time'] == null ? value['start_time'] : value['start_time'].toISOString(),
    end_time: value['end_time'] == null ? value['end_time'] : value['end_time'].toISOString(),
    executor_detail: V2beta1PipelineTaskExecutorDetailToJSON(value['executor_detail']),
    state: V2beta1RuntimeStateToJSON(value['state']),
    execution_id: value['execution_id'],
    error: GoogleRpcStatusToJSON(value['error']),
    inputs:
      value['inputs'] == null ? undefined : mapValues(value['inputs'], V2beta1ArtifactListToJSON),
    outputs:
      value['outputs'] == null ? undefined : mapValues(value['outputs'], V2beta1ArtifactListToJSON),
    parent_task_id: value['parent_task_id'],
    state_history:
      value['state_history'] == null
        ? undefined
        : (value['state_history'] as Array<any>).map(V2beta1RuntimeStatusToJSON),
    pod_name: value['pod_name'],
    child_tasks:
      value['child_tasks'] == null
        ? undefined
        : (value['child_tasks'] as Array<any>).map(PipelineTaskDetailChildTaskToJSON),
  };
}
